import { useAndReportExperimentTreatment } from '@ms/yammer-experiments-context';
import type { FC, PropsWithChildren } from 'react';
import React, { Suspense } from 'react';

import LoadableResizableLeftNavInner from './LoadableResizableLeftNavInner';
import { ResizableLeftNavFallback } from './ResizableLeftNavFallback';

export const ResizableLeftNavProvider: FC<PropsWithChildren> = ({ children }) => {
  const isEnabled = useAndReportExperimentTreatment('EngageIASimplificationNavRefresh');

  if (!isEnabled) {
    return <>{children}</>;
  }

  return (
    <Suspense fallback={<ResizableLeftNavFallback>{children}</ResizableLeftNavFallback>}>
      <LoadableResizableLeftNavInner>{children}</LoadableResizableLeftNavInner>
    </Suspense>
  );
};
